import { Collapse as MantineCollapse } from "@mantine/core";

export const Collapse = MantineCollapse;
